// extracted by mini-css-extract-plugin
export default {"placeholder":"dropdown_placeholder__vOqxz","menu":"dropdown_menu__dF4AL","control":"dropdown_control__1I2h6","lg":"dropdown_lg__HFNMy","right":"dropdown_right__OWaNk"};